import styled from '@emotion/styled';

import BG from '../../images/testimonials.png';
import { Iphone } from '../../svgs/Iphone';
import { Ipad } from '../../svgs/Ipad';
import { Laptop } from '../../svgs/Laptop';

export const TestimonialsBG = styled.div`
  background: url(${BG}) repeat;
`;

export const DevicePattern = styled.div`
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAF0lEQVQImWNgwAe0nFP/YwjAMH6V6AAA1rQJFif/QB4AAAAASUVORK5CYII=)
    repeat;
  height: 70%;
  top: 15%;
`;

export const ProductsWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 820px;
  display: flex;
  flex-direction: column;
`;

export const MobileIphone = styled(Iphone)`
  height: 130px;
  position: relative;
  top: 0;
  left: 16px;
`;

export const MobileIpad = styled(Ipad)`
  height: 130px;
  position: relative;
  top: 0;
  left: 16px;
`;

export const MobileLaptop = styled(Laptop)`
  height: 100px;
  position: relative;
  top: 0;
  left: 16px;
`;

export const DesktopIphone = styled(Iphone)`
  width: 55px;
  position: relative;
  top: 0;
  left: 4px;
  @media (min-width: 768px) {
    width: 70px;
  }
  @media (min-width: 1024px) {
    width: 83px;
  }
`;

export const DesktopIpad = styled(Ipad)`
  width: 70px;
  position: relative;
  top: 0;
  left: 4px;
  @media (min-width: 768px) {
    width: 90px;
  }
  @media (min-width: 1024px) {
    width: 107px;
  }
`;

export const DesktopLaptop = styled(Laptop)`
  width: 110px;
  position: relative;
  top: 0;
  left: 4px;
  @media (min-width: 768px) {
    width: 140px;
  }
  left: 4px;
  @media (min-width: 1024px) {
    width: 190px;
  }
`;
